module.exports = __webpack_public_path__ + "static/media/huli_204.10de0eec.gif";